"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FiscalYearUtilities = void 0;
const moment = __importStar(require("moment"));
const FISCAL_YEAR_START_MONTH = 9; // October (0 = January, …, 9 = October)
class FiscalYearUtilities {
    /**
     * Returns the fiscal year label for a given date.
     * If the month is ≥ October, it belongs to the next calendar year.
     */
    static getFiscalYearOfDate(timestamp) {
        const date = moment.utc(timestamp);
        const year = date.year();
        return date.month() >= FISCAL_YEAR_START_MONTH ? year + 1 : year;
    }
    /**
     * Returns the fiscal quarter (1–4) for a given date:
     * Q1 = Oct–Dec, Q2 = Jan–Mar, Q3 = Apr–Jun, Q4 = Jul–Sep.
     */
    static getFiscalQuarterOfDate(timestamp) {
        const date = moment.utc(timestamp);
        const monthIndex = date.month(); // 0 = Jan, …, 11 = Dec
        // Calculate position relative to fiscal start
        const offset = (monthIndex - FISCAL_YEAR_START_MONTH + 12) % 12;
        return (Math.floor(offset / 3) + 1);
    }
    /**
     * Returns the full fiscal year range:
     * from = October 1 of the year before the label,
     * to   = September 30 of the label year.
     */
    static getFiscalYearRange(timestamp) {
        const fiscalYear = this.getFiscalYearOfDate(timestamp);
        const startYear = fiscalYear - 1;
        const from = moment.utc([startYear, FISCAL_YEAR_START_MONTH, 1]).startOf('day').valueOf();
        const to = moment
            .utc([fiscalYear, FISCAL_YEAR_START_MONTH, 1])
            .subtract(1, 'day')
            .endOf('day')
            .valueOf();
        return { from, to };
    }
    /**
     * Returns the range for a fiscal quarter (1–4):
     * Q1 = Oct–Dec, Q2 = Jan–Mar, Q3 = Apr–Jun, Q4 = Jul–Sep.
     */
    static getFiscalYearQuarterRange(quarter, timestamp) {
        const fiscalYear = this.getFiscalYearOfDate(timestamp);
        const baseYear = fiscalYear - 1;
        // Calculate absolute start month index within a 0–11 cycle
        const absStart = FISCAL_YEAR_START_MONTH + (quarter - 1) * 3;
        const startYearOffset = Math.floor(absStart / 12);
        const startMonth = absStart % 12;
        const from = moment
            .utc([baseYear + startYearOffset, startMonth, 1])
            .startOf('day')
            .valueOf();
        // For end month, add 2 to the absolute index
        const absEnd = absStart + 2;
        const endYearOffset = Math.floor(absEnd / 12);
        const endMonth = absEnd % 12;
        const to = moment
            .utc([baseYear + endYearOffset, endMonth, 1])
            .endOf('month')
            .endOf('day')
            .valueOf();
        return { from, to };
    }
}
exports.FiscalYearUtilities = FiscalYearUtilities;
